import { DeepPartial, DeepReadonly } from 'ts-essentials';
import { ISectionProps, DeltaOf, ISectionData } from '@tencent/slide-sdk-model';
import { ISectionModel } from '@src/slide/domain/ui-model/element-modeles/Interface/section-model.interface';

/**
 * 节
 */
export class SectionPropertyConverter {
    /**
     * 节 sdk -> ui 属性映射
     * @param sdkData
     * @param uiData
     */
    public static convertPartialDataFromSdkToUi(
        sdkData: DeepReadonly<DeepPartial<ISectionProps>>,
        uiData: ISectionModel,
    ): void {
        if (sdkData.name) {
            uiData.name = sdkData.name;
        }
        if (sdkData.numSlides || sdkData.numSlides === 0) {
            uiData.numSlides = sdkData.numSlides;
        }
    }

    /**
     * 节 ui -> sdk 属性映射
     * @param uiData
     * @param sdkData
     */
    public static convertPartialDataFromUiToSdk(
        uiData: DeepPartial<ISectionModel>,
        sdkData: DeltaOf<ISectionData>,
    ): void {
        if (uiData.name) {
            sdkData.name = uiData.name;
        }
        if (uiData.numSlides || uiData.numSlides === 0) {
            sdkData.numSlides = uiData.numSlides;
        }
    }
}
